module.exports = __webpack_public_path__ + "images/tour/lesson_plan_by_day_add_remove_lesson-00a8bc6cd6eb9469493ccce5f5251384.gif";